export const reloadPage = () => {
  window.location.reload()
}
